import { Field, Model } from 'serialize-ts';

@Model()
export class MetaData {
  @Field()
  hasFood: boolean;
}
